/*eslint-disable*/
import Flickity from 'flickity'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default category_sliders => {
  let flkty_main, flkty_overlay, product_grid_position
  let overlay_slider = category_sliders.querySelector('.overlay_slider')
  let main_slider = category_sliders.querySelector('.main_slider')
  const leftArrow = document.querySelector('.js-left-arrow')
  const rightArrow = document.querySelector('.js-right-arrow')
  $(document).ready(() => $('body').css({ width: '100%', position: 'fixed' })) //To ensure header doesn't get pushed out of view when flickity slider is loading (due to fixed position snowe header)
  let global_params = {
    wrapAround: true,
    cellAlign: 'center',
    adaptiveHeight: true,
    prevNextButtons: false,
    imagesLoaded: true,
    percentPosition: false,
  }
  let main_params = {
    draggable: true,
    autoPlay: 15000,
    selectedAttraction: 0.025,
    hash: true,
    on: {
      ready: () => {
        // flickity to select first slide based on URL # if it exists
        let selected = $('.main_slider').find('.is-selected').data('id')
        let index = $('.main_slider').find('.hgg-category-slider_container.is-selected').data('index')
        let chapter_copy = `<span class='maison caps fw6' style='font-style:normal'>Chapter ${index + 1}: </span>`
        let footer_copy = $('.main_slider').find('.hgg-category-slider_container.is-selected').data('footer-copy')
        let footer_lowered_mobile = $('.main_slider').find('.is-selected').data('footer-lowered')
        let footer_cta_link = $('.main_slider').find('.hgg-category-slider_container.is-selected').data('page-link')

        $('.hgg-top-nav').find(`#${selected}`).addClass('selected')
        setTimeout(() => {
          $('.main_slider .is-selected .hgg-category_footer').addClass('focused')
          $('.collection__arrow').addClass('loaded')
          // $(category_sliders).find('.slider-border.left h4').addClass('focused').text(`Chapter 0${index+1}`)
          $(category_sliders).find('.border-container .hgg-category_footer').addClass('focused')
          footer_lowered_mobile === true
            ? $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy').addClass('single-line-lowered')
            : $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy').removeClass('single-line-lowered')
          $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy').html(footer_copy)
          $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy p').prepend(chapter_copy) /*selects hero title and updates text*/
          $(category_sliders).find('.border-container .hgg-category_footer .snowe-button-global a').attr('href', footer_cta_link)
        }, 500)
        //PRODUCT GRID TRANSITIONS
        $(`.hgg-product-grid[data-id=${selected}], .hgg-recirc-module[data-id=${selected}]`).removeClass('hidden')
        setTimeout(() => {
          product_grid_position = $(`.hgg-product-grid[data-id=${selected}]`).offset();
          $(`.hgg-product-grid[data-id=${selected}], .hgg-recirc-module[data-id=${selected}]`).addClass('focused current-selection')
          $('.snowe__loader').addClass('hide')
          $(document).ready(() => $('body').css({ position: 'inherit', width: 'inherit' })) //To ensure scrolling is re-enabled after flickity slider has loaded       
        }, 500)
        //END PRODUCT GRID TRANSITIONS
        setTimeout(() => { $(`.main_slider .hgg-category-slider_container.is-selected`).find('.hgg-arrow-tips-overlay .arrow-tip-1').addClass('focused') }, 1000)
        setTimeout(() => { $(`.main_slider .hgg-category-slider_container.is-selected`).find('.hgg-arrow-tips-overlay .arrow-tip-2').addClass('focused') }, 2000)
        setTimeout(() => { $(`.main_slider .hgg-category-slider_container.is-selected`).find('.hgg-arrow-tips-overlay .arrow-tip-3').addClass('focused') }, 3000)
      },
      change: () => {
        let selected = $('.main_slider .hgg-category-slider_container.is-selected').data('id')
        let index = $('.main_slider').find('.hgg-category-slider_container.is-selected').data('index')
        let footer_copy = $('.main_slider').find('.hgg-category-slider_container.is-selected').data('footer-copy')
        let chapter_copy = `<span class='maison caps fw6' style='font-style:normal'>Chapter ${index + 1}: </span>`
        let footer_lowered_mobile = $('.main_slider').find('.is-selected').data('footer-lowered')
        let footer_cta_link = $('.main_slider').find('.hgg-category-slider_container.is-selected').data('page-link')

        setTimeout(() => { flkty_overlay && flkty_overlay.select(index) }, 75) // triggers overlay flkty to also change
        $('.hgg-top-nav .js-nav-category').removeClass('selected')/* deselects top nav*/
        $('.border-container .hgg-category_footer').removeClass('focused') /* deselects hero footer dek, and cta*/
        $(category_sliders).find('.slider-border.left h4').removeClass('focused') /* deselects hero title*/
        $('.main_slider').find('.arrow-tip-1, .arrow-tip-2, .arrow-tip-3').removeClass('focused') /* deselects arrow tips title*/

        $('.hgg-top-nav').find(`#${selected}`).addClass('selected') /* selects new top nav */
        setTimeout(() => {
          footer_lowered_mobile === true
            ? $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy').addClass('single-line-lowered')
            : $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy').removeClass('single-line-lowered')
          $('.main_slider').find('.is-selected').find('.hgg-category_footer').addClass('focused') /*selects hero footer dek and cta*/
          $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy').html(footer_copy) /*updates hero footer dek copy */
          $(category_sliders).find('.border-container .hgg-category_footer .hgg-category_footer_copy p').prepend(chapter_copy) /*selects hero title and updates text*/
          $(category_sliders).find('.border-container .hgg-category_footer').addClass('focused')
          $(category_sliders).find('.border-container .hgg-category_footer .snowe-button-global a').attr('href', footer_cta_link) /*updates hero CTA href*/
        }, 500)

        //PRODUCT GRID TRANSITIONS
        $(`.hgg-product-grid.current-selection, .hgg-recirc-module.current-selection`).removeClass('focused')
        setTimeout(() => {
          $(`.hgg-product-grid.current-selection, .hgg-recirc-module.current-selection`).addClass('hidden').removeClass('current-selection')
          $(`.hgg-product-grid[data-id=${selected}], .hgg-recirc-module[data-id=${selected}]`).removeClass('hidden')
          setTimeout(() => { $(`.hgg-product-grid[data-id=${selected}], .hgg-recirc-module[data-id=${selected}]`).addClass('focused current-selection') }, 100)
        }, 500)
        //END PRODUCT GRID TRANSITIONS
        setTimeout(() => { $(`.main_slider .hgg-category-slider_container.is-selected`).find('.hgg-arrow-tips-overlay .arrow-tip-1').addClass('focused') }, 1000)
        setTimeout(() => { $(`.main_slider .hgg-category-slider_container.is-selected`).find('.hgg-arrow-tips-overlay .arrow-tip-2').addClass('focused') }, 2000)
        setTimeout(() => { $(`.main_slider .hgg-category-slider_container.is-selected`).find('.hgg-arrow-tips-overlay .arrow-tip-3').addClass('focused') }, 3000)
      }
    }
  }

  let overlay_params = {
    draggable: false,
    autoPlay: false,
    selectedAttraction: 0.025,
  }

  const setFlickity = (slider) => {
    if ($(slider).hasClass('main_slider')) flkty_main = new Flickity(slider, { ...global_params, ...main_params })
    else if ($(slider).hasClass('overlay_slider')) flkty_overlay = new Flickity(slider, { ...global_params, ...overlay_params })
  }

  $(window).load(() => {
    setFlickity(main_slider)
    setFlickity(overlay_slider)
    let url_hash = window.location.hash.split("#")[1]
    url_hash && flkty_main && flkty_main.select($(`.hgg-category-slider_container[data-id=${url_hash}]`).data('index'))

    $(leftArrow).click(() => setTimeout(() => { flkty_main && flkty_main.previous() }, 0))
    $(rightArrow).click(() => setTimeout(() => { flkty_main && flkty_main.next() }, 0))
    $('.hgg-top-nav .js-nav-category').each((i, navCategory) => {
      $(navCategory).click((event) => {
        let selected_slider_index = $(`.hgg-category-slider_container[data-id=${event.target.id}]`).data('index')
        flkty_main && flkty_main.select(selected_slider_index)
        setTimeout(() => { flkty_overlay && flkty_overlay.select(selected_slider_index) }, 75)
      })
    })
    flkty_main && flkty_main.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty_main && flkty_main.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    setTimeout(() => {
      flkty_main && flkty_main.resize()
      flkty_overlay && flkty_overlay.resize()
      $('.hgg_categories_container .snowe_slideshow_arrows').css('opacity', 1)
    }, 1500)
    $(window).on('resize', () => {
      flkty_main && flkty_main.resize()
      flkty_overlay && flkty_overlay.resize()
      window.matchMedia('(min-width:769px)').matches
        && $('.main_slider .hgg-category-slider_container').each((idx, slider) => $(slider).find('img.hgg-category_image').attr('src', $(slider).find('img.hgg-category_image').data('image-src')))
      window.matchMedia('(max-width:768px)').matches
        && $('.main_slider .hgg-category-slider_container').each((idx, slider) => $(slider).find('img.hgg-category_image').attr('src', $(slider).find('img.hgg-category_image').data('mobile-image-src')))
    })

    window.matchMedia('(min-width:769px)').matches
      && $('.main_slider .hgg-category-slider_container').each((idx, slider) => $(slider).find('img.hgg-category_image').attr('src', $(slider).find('img.hgg-category_image').data('image-src')))
    window.matchMedia('(max-width:768px)').matches
      && $('.main_slider .hgg-category-slider_container').each((idx, slider) => $(slider).find('img.hgg-category_image').attr('src', $(slider).find('img.hgg-category_image').data('mobile-image-src')))

    $(window).on('scroll', () => {
      window.scrollY >= 100
        ? flkty_main.stopPlayer()
        : flkty_main.playPlayer()
    })
  })


  //Prevents users from holding down left or right keys to cycle through products at superspeed, potentially double exposing stories and product grids. 
  let keyup = true;
  $("body").on("keyup", e => {
    let code = e.keyCode;
    if (code === 37) keyup = true
    if (code === 39) keyup = true
  })
  Flickity.prototype.onkeydown = function (event) {
    // only work if element is in focus
    if (!this.options.accessibility ||
      (document.activeElement && document.activeElement != this.element)) {
      return;
    }
    if (event.keyCode == 37 && keyup) {
      // go left
      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
      this.uiChange();
      this[leftMethod]();
      keyup = false
    } else if (event.keyCode == 39 && keyup) {
      // go right
      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
      this.uiChange();
      this[rightMethod]();
      keyup = false
    }
  };
}

let header = document.querySelector('.hgg-top-nav');
var origOffsetY = header.offsetTop;

function onScroll(e) {
  window.scrollY >= origOffsetY ? header.classList.add('sticky') :
                                  header.classList.remove('sticky');
}

document.addEventListener('scroll', onScroll);




// WEBPACK FOOTER //
// ./src/scripts/components/holiday-gift-guide-20-category-slider.js